import { type FC } from 'react';
import { type TabBarItemsType } from '@common/types/components';

import goodsIcon from '/img/tabbar/goods.svg';
import goodsActiveIcon from '/img/tabbar/goods-active.svg';
import materialsIcon from '/img/tabbar/materials.svg';
import materialsActiveIcon from '/img/tabbar/materials-active.svg';
import officeIcon from '/img/tabbar/office.svg';
import officeActiveIcon from '/img/tabbar/office-active.svg';
import resourcesIcon from '/img/tabbar/resources.svg';
import resourcesActiveIcon from '/img/tabbar/resources-active.svg';
import stockIcon from '/img/tabbar/stock.svg';
import stockActiveIcon from '/img/tabbar/stock-active.svg';

interface NavigateIconProps {
  label: TabBarItemsType;
  isActive: boolean;
  onboardingOverflow?: boolean;
}

const NavigateIcon: FC<NavigateIconProps> = ({
  label,
  isActive,
  onboardingOverflow,
}) => {
  const image: Record<TabBarItemsType, { active: string; inactive: string }> = {
    Office: {
      active: officeActiveIcon,
      inactive: officeIcon,
    },

    Resources: {
      active: resourcesActiveIcon,
      inactive: resourcesIcon,
    },
    Materials: {
      active: materialsActiveIcon,
      inactive: materialsIcon,
    },
    Goods: {
      active: goodsActiveIcon,
      inactive: goodsIcon,
    },
    Stock: {
      active: stockActiveIcon,
      inactive: stockIcon,
    },
  };

  const status = isActive ? 'active' : 'inactive';

  return (
    <div className="relative w-8 h-8 shrink-0 z-10 ">
      <img
        className={`absolute w-8 h-8 transition-opacity duration-500 ${
          onboardingOverflow ? 'opacity-100' : 'opacity-0'
        }`}
        src={image[label].active}
        alt={`${label} active`}
      />
      <img className="w-8 h-8 shrink-0" src={image[label][status]} />
    </div>
  );
};

export { NavigateIcon };
